export default __webpack_public_path__ + "locales/uk-UA/DeleteProfileEverDialog.json?hash=078e6f38bc406c3a8f944ed90dce67ec";